import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('taskNotification', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
]);

export const initialTaskNotificationState = {
    ...generateDefaultState('taskNotification', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
    ]),
};